import React from "react";
import { Flame, ArrowUpRight } from "lucide-react";
import SectionNumber from "./SectionNumber";

export default function Gastronomy() {
  return (
    <section
      id="etelek"
      data-testid="gastronomy-section"
      className="relative bg-pkbeige py-24 sm:py-32 overflow-hidden"
    >
      <SectionNumber n="02" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image stack */}
        <div className="lg:col-span-7 reveal">
          <div className="relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src="/images/jd0m09ac.jpg"
                alt="Szabadtűzi sütés"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pkcharcoal/40 to-transparent" />
            </div>
            <div className="hidden sm:block absolute -bottom-12 -right-6 w-1/2 aspect-square overflow-hidden border-8 border-pkbeige shadow-2xl">
              <img
                src="/images/fquinro5.jpg"
                alt="Kemencés focaccia"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-6 -left-4 bg-pkred text-white px-5 py-3 shadow-lg">
              <div className="text-[0.65rem] tracking-[0.3em] uppercase opacity-90">
                Lassan készül
              </div>
              <div className="font-serif text-2xl leading-none mt-1">
                400°C+
              </div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-5 reveal">
          <span className="eyebrow">Gasztronómia</span>
          <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            Szabadtűzi ízek,
            <br />
            amiket <span className="italic text-pkred">nem lehet</span>{" "}
            siettetni.
          </h2>
          <p className="mt-8 text-pkcharcoal/75 text-base sm:text-lg leading-relaxed">
            Húsok, piték, zöldségek, kenyerek és tematikus vacsorák készülnek
            nyílt tűzön, kemencében és hagyományos technikákkal. Balkáni,
            magyaros és olasz ízvilág találkozik a parázs melegével.
          </p>

          <div className="mt-10 space-y-4">
            {[
              { t: "Parázs felett", d: "Húsok és zöldségek nyílt tűzön." },
              { t: "Kemencében", d: "Kenyerek, piták, pizzák, piték." },
              { t: "Föld alatt", d: "Hagyományos lassú sütés, bosnyák módra." },
            ].map((item) => (
              <div
                key={item.t}
                className="flex items-start gap-4 group cursor-default"
              >
                <Flame
                  className="w-5 h-5 text-pkred mt-1 group-hover:scale-110 transition-transform shrink-0"
                  strokeWidth={1.5}
                />
                <div>
                  <div className="font-semibold text-pkcharcoal text-base">
                    {item.t}
                  </div>
                  <div className="text-pkcharcoal/65 text-sm">{item.d}</div>
                </div>
              </div>
            ))}
          </div>

          <a
            href="#programok"
            data-testid="gastronomy-cta"
            className="inline-flex items-center gap-2 mt-12 text-pkcharcoal hover:text-pkred transition-colors font-semibold text-sm tracking-[0.15em] uppercase group"
          >
            Ételek és tematikus estek
            <ArrowUpRight
              className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
              strokeWidth={1.8}
            />
          </a>
        </div>
      </div>
    </section>
  );
}
